import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import {
  Stack,
  Button,
  InputLabel,
  TextField,
  Typography,
  FormControlLabel,
  Box,
  Checkbox,
} from "@mui/material";
import * as yup from "yup";
import { Formik, Form } from "formik";
import { IconButton } from "@mui/material";
import { ReactComponent as CloseOutlined } from "../../assets/icons/close_icon.svg";
import VerificationDialog from "./VerificationDialog";
import { useState, useRef } from "react";
import { doSendOtp } from "../../reducers/auth/auth.service";
import { useDispatch } from "react-redux";
import { enqueueSnackbar } from "notistack";

const validationSchema = yup.object().shape({
  email: yup
    .string()
    .trim()
    .email("Please enter a valid email")
    .required("Email is required"),
});

const initialValues = {
  email: "",
};

function maskEmail(currEmail) {
  let maskedEmail = "";
  if (currEmail) {
    let name = currEmail.split("@")[0];
    let domain = currEmail.split("@")[1];
    if (name.length > 2) {
      maskedEmail =
        name[0] +
        name[1] +
        Array.from({ length: name.length - 2 })
          .fill("*")
          .join("") +
        "@" +
        domain;
    } else {
      maskedEmail =
        Array.from({ length: name.length }).fill("*").join("") + "@" + domain;
    }
  }
  return maskedEmail;
}

const LoginDialog = ({
  open,
  handleDialogClose,
  handleOpenLogin,
  displayAsLogin = false,
  showTelegramJoin = true,
}) => {
  const dispatch = useDispatch();

  // Handle otp dialog
  const [openOtp, setOpenOtp] = useState(false);
  const handleCloseOtp = () => setOpenOtp(false);
  const handleOpenOtp = () => setOpenOtp(true);

  // Passing masked and original email to otp dialog
  let maskedEmail = useRef(null);
  let originalEmail = useRef(null);

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={async (values, { resetForm, setSubmitting }) => {
          setSubmitting(true);
          const trimmedValues = {};
          for (const key in values) {
            if (values.hasOwnProperty(key)) {
              if (typeof values[key] === "string") {
                trimmedValues[key] = values[key].trim();
              } else {
                trimmedValues[key] = values[key];
              }
            }
          }

          maskedEmail.current = maskEmail(trimmedValues.email);
          originalEmail.current = trimmedValues.email;

          const responseValue = await dispatch(
            doSendOtp({
              email: originalEmail.current,
            })
          );
          if (doSendOtp.fulfilled.match(responseValue)) {
            enqueueSnackbar("OTP Sent Successfully", {
              variant: "success",
            });
            handleDialogClose();
            handleOpenOtp();
          } else {
            if (responseValue.payload.status === 422) {
              enqueueSnackbar("You are blocked by admin", {
                variant: "error",
              });
            } else {
              enqueueSnackbar("Error sending OTP", {
                variant: "error",
              });
            }
          }
          resetForm();
          setSubmitting(false);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          resetForm,
          isSubmitting,
        }) => (
          <Form>
            <Dialog
              scroll="body"
              open={open}
              onClose={() => {
                resetForm();
                handleDialogClose();
              }}
              fullWidth
              disableScrollLock={false}
              slotProps={{
                paper: {
                  component: "form",
                  sx: {
                    px: { xs: "20px !important", sm: "56px !important" },
                    borderRadius: {
                      xs: "20px !important",
                      sm: "50px !important",
                    },
                  },
                },
              }}
            >
              <DialogTitle
                variant="h3"
                sx={{
                  textAlign: "center",
                  p: 0,
                  mt: { sm: "15px", xs: "40px" },
                  fontWeight: 700,
                  mb: "50px",
                }}
              >
                {displayAsLogin
                  ? "LOGIN"
                  : "GET THE DATA EDGE – SIGN UP NOW!"}
              </DialogTitle>

              {/* <Typography
                sx={{
                  color: "white",
                  textAlign: "center",
                  fontFamily: "secondaryFontFamily",
                  fontSize: "14px",
                  fontWeight: 300,
                  mb: "50px",
                }}
              >
                GET THE DATA EDGE – SIGN UP NOW!
              </Typography> */}

              <IconButton
                aria-label="close"
                onClick={() => {
                  resetForm();
                  handleDialogClose();
                }}
                sx={{
                  position: "absolute",
                  right: 20,
                  top: 20,
                  fontSize: "25px",
                  color: "#999999",
                }}
              >
                {" "}
                <CloseOutlined />
              </IconButton>
              <Stack direction={"column"} gap={{ md: 3, xs: 2 }}>
                <Box>
                  <InputLabel sx={{ color: "#1D1D3E", mb: "5px" }}>
                    Email
                  </InputLabel>
                  <TextField
                    name="email"
                    placeholder="Enter email"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.email && Boolean(errors.email)}
                    helperText={touched.email && errors.email}
                    variant="outlined"
                    sx={{ width: "100%" }}
                  ></TextField>
                </Box>
                {/* {showTelegramJoin && (
                  <FormControlLabel
                    name="isTelegramJoined"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    sx={{
                      ".MuiCheckbox-root": {
                        padding: "0px !important",
                      },
                      ".MuiTypography-root": {
                        color: "white",
                        fontFamily: "secondaryFontFamily",
                      },
                      gap: 1,
                      ml: "0px",
                    }}
                    control={<Checkbox checked={values.isTelegramJoined} />}
                    label="Join telegram"
                  />
                )} */}
                <Button
                  disabled={isSubmitting}
                  variant="contained"
                  type="submit"
                  sx={{
                    my: "30px",
                    width: "105px",
                    ml: "auto",
                    p: "10px 10px 6px 10px !important",
                  }}
                >
                  Continue
                </Button>
              </Stack>
            </Dialog>
          </Form>
        )}
      </Formik>

      <VerificationDialog
        open={openOtp}
        handleDialogClose={handleCloseOtp}
        maskedEmail={maskedEmail.current}
        originalEmail={originalEmail.current}
        handleOpenLogin={handleOpenLogin}
      />
    </>
  );
};

export default LoginDialog;
